import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { ViewContainer } from 'xray-recommendation-lib/sectionViews/ViewContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const wrapActionsWithDispatch = (editorApi, dispatch) => {
  return Object.entries(editorApi).reduce((editorApiWithDispatch, api) => {
    const [name, action] = api;
    editorApiWithDispatch[name] = (...args) => dispatch(action(...args));
    return editorApiWithDispatch;
  }, {});
};
const XRayPatagoniaRecommendationContainer = ({
  artifacts,
  config,
  auditResults,
  auth,
  contentId,
  tracker
}) => {
  const dispatch = useDispatch();
  const configWithWrappedActions = useMemo(() => Object.assign({}, config, {
    editorApi: wrapActionsWithDispatch(config.editorApi, dispatch)
  }), [config, dispatch]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ViewContainer, {
      auditResults: auditResults,
      config: configWithWrappedActions,
      artifacts: artifacts,
      contentId: contentId,
      auth: auth,
      tracker: tracker
    }), /*#__PURE__*/_jsx(NavMarker, {
      name: "OPTIMIZE_TAB_RENDERED"
    })]
  });
};
export default XRayPatagoniaRecommendationContainer;